import { ListFilter } from "./Filter";

export class GenericResponse {
    id: number;
    success: boolean;
    error: string;
    errors: any[];
    page: any;
    data: any;
    item: any;
    items: any[];
}

export class GenericTypeResponse<T> {
    id: number;
    success: boolean;
    error: string;
    errors: any[];
    data: T;
    item: T;
    items: T[];
}

export class BlobResponse {
    name: string;
    success: boolean;
    error: string;
    errors: any[];
    data: Blob;
}

export class NameValueItem {
    Name: string;
    Value: string;
}

export class GenericFilter extends ListFilter {
    Type: string;
}
